// Query-Keys und Konstanten für Lesezeichen (docs/API.md 3.11).
import type { BookmarkDto, BookmarkFolderDto } from '@lagerfeuer/shared';
import { compareSnowflakes } from '@lagerfeuer/shared';

/** Präfix aller Lesezeichen-Queries (Ordner + Listen). */
export const BOOKMARKS_KEY = ['extras', 'bookmarks'] as const;
export const BOOKMARK_FOLDERS_KEY = [...BOOKMARKS_KEY, 'folders'] as const;
/** Filter: 'all' = alle, 'none' = ohne Ordner, sonst Ordner-ID. */
export type BookmarkFilter = 'all' | 'none' | (string & {});
export const bookmarkListKey = (filter: BookmarkFilter) => [...BOOKMARKS_KEY, 'list', filter] as const;

export const BOOKMARK_PAGE_SIZE = 50;
/** Annahme (Vertrag nennt keine Grenze): Ordnernamen höchstens 100 Zeichen. */
export const FOLDER_NAME_MAX = 100;

/** Farbpalette (Lagerfeuer-Töne); eigene Farben über <input type=color>. */
export const FOLDER_PALETTE = ['#ff7a18', '#ffd166', '#e5484d', '#3fb97a', '#4cc9f0', '#7c8cff', '#c77dff', '#b8a99a'] as const;

export function sortFolders(folders: BookmarkFolderDto[]): BookmarkFolderDto[] {
  return [...folders].sort((a, b) => a.position - b.position || compareSnowflakes(a.id, b.id));
}

/** Kleinste ID einer Seite (Cursor für „Ältere laden"). */
export function oldestId(page: BookmarkDto[]): string | undefined {
  return page.reduce<string | undefined>((min, b) => (min === undefined || compareSnowflakes(b.id, min) < 0 ? b.id : min), undefined);
}

/** Seiten zusammenführen, doppelte entfernen, neueste zuerst. */
export function flattenBookmarks(pages: BookmarkDto[][]): BookmarkDto[] {
  const map = new Map<string, BookmarkDto>();
  for (const page of pages) for (const b of page) map.set(b.id, b);
  return [...map.values()].sort((a, b) => compareSnowflakes(b.id, a.id));
}
